module.exports = __webpack_public_path__ + "public/StoreIcon/closeIconRes.png?1b6d22c6";